
/**
 * @description format default value to be displayed if the given value is null/undefined
 * '-' is default value displayed
 *
 * @param val value to be displayed
 * @param defaultValue (default '-') string to be displayed if the given value is null/undefined
 *
 * @returns value if not null or '-'/defined defaultValue if null
 */
export const formatDefault = (val: string | number | undefined | null, defaultValue = '-') => {
  return val || defaultValue;
};
